var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFields = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.688 11.806c.044.123.069.262.069.408a1.2 1.2 0 0 1-.07.409l.236.233a.91.91 0 0 0 1.007.222.91.91 0 0 0 .57-.857.9.9 0 0 0-.29-.648L16.048 6.43a.912.912 0 0 0-1.498.988.9.9 0 0 0 .21.295l3.607 3.594H8.251c-.354 0-.64.406-.64.907 0 .502.287.908.64.908h10.116l-3.606 3.594a.908.908 0 0 0 .992 1.493.9.9 0 0 0 .295-.21l5.162-5.143a.906.906 0 0 0-.637-1.572.91.91 0 0 0-.65.289zM4.22 5.357a.85.85 0 0 0-.531-.792.863.863 0 0 0-1.125.464.9.9 0 0 0-.065.328v13.286a.855.855 0 0 0 .86.857.86.86 0 0 0 .86-.857V5.357Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFields);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fields.b0a1b926.svg";